import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import "./Main.css";
import "./Home.css";
import TopNav from "./TopNav";
import MainNav from "./MainNav";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";
import LoginFail from "../util/LoginFail";
import HomeCard from "../util/HomeCard";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Moment from "react-moment";
import { subDays } from "date-fns";
import { format } from "date-fns";
import ko from "date-fns/locale/ko";
import pr from "../lib/pr.js";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import { loginState, configState } from "../lib/State";
import Layout from "./Layout";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import { Box } from "@mui/material";
import PosCardCalendar from "./PosCardCalendar";
import ReportCardList from "./ReportCardList";
import queryString from "query-string";

export default function PosCard() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [tcid, setTcid] = useState('');

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  return (
    <Layout login={login}>
      <ReportCardList tcidParent={tcid} login={login}></ReportCardList>
    </Layout>
  );
}
